import { AlertTriangle, X } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@repo/ui/components/ui/alert";
import { Button } from "@repo/ui/components/ui/button";
import { alertBannerStyles as s } from "./AlertBanner.styles";
import type { AlertBannerProps } from "./AlertBanner.types";
export type { AlertBannerData } from "./AlertBanner.types";

export function AlertBanner({
  title,
  subtitle,
  actionLabel,
  onAction,
  onDismiss,
  variant = "card",
}: AlertBannerProps) {
  if (variant === "banner") {
    return (
      <Alert className={s.bannerRoot}>
        <AlertTriangle className={s.bannerIcon} />
        <div className="min-w-0 flex-1">
          <span className={s.bannerTitle}>{title}</span>
          <span className={s.bannerSubtitle}>{subtitle}</span>
        </div>
        <button onClick={onAction} className={s.bannerAction}>
          {actionLabel} →
        </button>
        <button onClick={onDismiss} className={s.bannerDismiss} aria-label="Dismiss alert">
          <X className={s.dismissIcon} />
        </button>
      </Alert>
    );
  }

  return (
    <Alert className={s.cardRoot}>
      <AlertTriangle className={s.cardIcon} />
      <AlertTitle className={s.cardTitle}>{title}</AlertTitle>
      <AlertDescription className={s.cardDescription}>{subtitle}</AlertDescription>
      <button onClick={onDismiss} className={s.cardDismiss} aria-label="Dismiss alert">
        <X className={s.dismissIcon} />
      </button>
      <Button onClick={onAction} className={s.cardButton}>
        {actionLabel}
      </Button>
    </Alert>
  );
}
